import { render, staticRenderFns } from "./paymentsettings.vue?vue&type=template&id=c1efb8a6&scoped=true"
import script from "./paymentsettings.vue?vue&type=script&lang=js"
export * from "./paymentsettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1efb8a6",
  null
  
)

export default component.exports